import React from 'react'
import './Footer.scss'

const Footer = () => {
    return (

        <section className="footer">

            <div className="box-container">

                <div className="box">
                    <h3>quick links</h3>
                    {
                        [
                            'home',
                            'services',
                            'gallery',
                            'pricing',
                            'review',
                            'contact'
                        ].map(link => (
                            <a key={link} href={`#${link}`}>
                                <i className="fas fa-chevron-right"></i>
                                {link}
                            </a>
                        ))
                    }
                </div>

                <div className="box">
                    <h3>follow us</h3>
                    {
                        [
                            'facebook',
                            'twitter',
                            'instagram',
                            'linkedin',
                            'pinterest',
                            'whatsapp'
                        ].map(link => (
                            <a href={`https://${link}.com/`} key={link} target="_blank" rel="noreferrer">
                                <i className={`fab fa-${link}`}></i>
                                {link}
                            </a>
                        ))
                    }
                </div>

                <div className="box">
                    <h3>download app</h3>

                    {
                        [
                            ['windows', 'windows' , 'microsoft'],
                            ['apple', 'app store' , 'apple'],
                            ['google-play', 'play store' , 'play.google'],
                        ].map(store => (
                            <a href={`https://${store[2]}.com/`} key={store[0]} target="_blank" rel="noreferrer">
                                <i className={`fab fa-${store[0]}`}></i>
                                {store[1]}
                            </a>
                        ))
                    }

                </div>

                <div className="box">
                    <h3>contact info</h3>
                    <a href="/#"> <i className="fas fa-phone"></i> +880 1717 416 412 </a>
                    <a href="/#"> <i className="fas fa-envelope"></i> taiseen.cse@gmail.com </a>
                    <a href="/#"> <i className="fas fa-map-marker-alt"></i> dhaka, bangladesh </a>
                </div>

            </div>

            <div className="credit">
                &copy; Copyright 2022 by <span>taiseen</span> | all rights reserved
            </div>
        </section>

    )
}

export default Footer